<template>
	<div id="app">
		<nav>
			<router-link class='nav_add' to='/add' title='add vocabulary'>
				<svg viewBox="0 0 112 113">
					<text x="-10px" y="112.08px">+</text>
				</svg>
			</router-link>
			<router-link class='nav_question' to="/" title='ask me vocabulary'>
				<svg viewBox="0 0 102 162">
					<text x="-10px" y="161.08px">?</text>
				</svg>
			</router-link>
		</nav>
		<router-view></router-view>
	</div>
</template>

<script>
import AddVocab from './components/AddVocab';
import QuestionVocab from './components/QuestionVocab';

export default {
	name: 'app',
	components: {AddVocab, QuestionVocab}
};
</script>

<style>

html,
body {
	height: 100%;
	min-height: 100%;
}

body {
	--blue1: #2c3e50;
	--fontx15: 1.5rem;
	--fontx20: 2.0rem;
	--fontx25: 2.5rem;
	--fontx30: 3rem;
	background: var(--blue1);
	/*background: #191A1C;*/
	/*background: #434D55;*/
	/*color: #554D48;*/
	line-height: 1.5;
	/*TODO: DO PROPER FONT RESEARCH*/
	/*font-family: 'Helvetica', Arial, sans-serif;*/
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-rendering: optimizeLegibility;
	overflow-x: hidden;
	margin: 0;
	text-overflow: ellipsis;
	word-break: keep-all;
}

#app {
	min-height: 100%;
	display: grid;
	grid-template-columns: 5% 90% 5%;
	grid-template-rows: 20% 60% 20%;
	grid-template-areas: 
		". header ."
		". main ."
		". footer .";
}

nav {
	grid-area: header;
	align-self: center;
	justify-self: center;
}

nav a:not(:last-child) {
	margin-right: 2rem;
}

.nav_add > svg {
	fill-rule:evenodd;
	clip-rule:evenodd;
	stroke-linejoin:round;
	stroke-miterlimit:1.41421;
	height: var(--fontx15);
	width: var(--fontx15);
}

.nav_add > svg > text, .nav_question > svg > text {
	font-size:220px;
	fill:#fff;
}

.nav_question > svg {
	fill-rule:evenodd;
	clip-rule:evenodd;
	stroke-linejoin:round;
	stroke-miterlimit:1.41421;
	height: var(--fontx15);
	width: var(--fontx15);
}

.nav_question > svg > text {
	font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// App.vue?09a81a33